/**
 * PULL.1 §6 — scan feedback: flash + beep + vibrate.
 */

let audioCtx = null;

const getCtx = () => {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!audioCtx) audioCtx = new AC();
  return audioCtx;
};

const tone = (freq, ms, type = "square") => {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume?.();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    gain.gain.value = 0.08;
    osc.connect(gain);
    gain.connect(ctx.destination);
    const now = ctx.currentTime;
    osc.start(now);
    gain.gain.exponentialRampToValueAtTime(0.001, now + ms / 1000);
    osc.stop(now + ms / 1000 + 0.02);
  } catch {
    /* ignore audio failures on locked devices */
  }
};

export const beepOk = () => tone(880, 90);
export const beepBad = () => {
  tone(220, 280);
  setTimeout(() => tone(180, 220), 120);
};

export const vibrateOk = () => {
  try {
    navigator?.vibrate?.(40);
  } catch {
    /* */
  }
};

export const vibrateBad = () => {
  try {
    navigator?.vibrate?.([80, 40, 80]);
  } catch {
    /* */
  }
};

/**
 * Flash the handheld shell. Pass a ref to the shell root, or a CSS class
 * toggled on documentElement.
 */
export const flashShell = (el, toneName = "ok", ms = 280) => {
  const node = el?.current || el;
  if (!node || !node.classList) return;
  const cls =
    toneName === "bad" ? "hh-shell--flash-bad" : "hh-shell--flash-ok";
  node.classList.remove("hh-shell--flash-ok", "hh-shell--flash-bad");
  // force reflow so repeated flashes retrigger
  void node.offsetWidth;
  node.classList.add(cls);
  setTimeout(() => node.classList.remove(cls), ms);
};

export const feedbackOk = (shellRef) => {
  beepOk();
  vibrateOk();
  flashShell(shellRef, "ok");
};

export const feedbackBad = (shellRef) => {
  beepBad();
  vibrateBad();
  flashShell(shellRef, "bad", 420);
};
